import api from 'api';

export const loadNetworks = api(
  'GET /api/marketing-planning/summary-by-owners/:year/:month/filters/networks'
);
export const loadApplications = api(
  'GET /api/marketing-planning/summary-by-owners/:year/:month/filters/applications'
);
export const loadManagers = api(
  'GET /api/marketing-planning/summary-by-owners/:year/:month/filters/managers'
);

export const loadSummaryByOwners = api(
  'POST /api/marketing-planning/summary-by-owners/:year/:month'
);
